export default "__VITE_ASSET__DM6qA1iB__"